import * as React from "react";
import { TextField } from "@mui/material";

export interface Props {
  currentValue: number | string;
  fieldName: string;
  value: any;
  setValue: (object: any) => void;
  label?: string;
  id?: string;
  placeholder?: string;
  maxValue?: number;
  disabled?: boolean;
  errorText?: string;
  className?: string;
  shrink?: boolean;
  hideLabel?: boolean;
}

function NumericalInputField({
  currentValue,
  fieldName,
  value,
  setValue,
  label,
  id,
  placeholder,
  disabled,
  errorText,
  maxValue,
  className,
  shrink,
  hideLabel,
}: Props) {
  const maxIntLength = maxValue
    ? Math.floor(Math.log(maxValue) * Math.LOG10E + 1)
    : null;
  const regEx = `^[0-9]{0,${maxIntLength}}$`;
  const handleChange = (event: any) => {
    if (regEx && RegExp(regEx).test(event.target.value)) {
      setValue({ ...value, [fieldName]: parseInt(event.target.value) });
    }
  };

  const inputLabel =
    maxValue && Number(currentValue) > maxValue ? "Error" : label;

  const helperText =
    maxValue && Number(currentValue) > maxValue ? errorText : "";
  return (
    <TextField
      InputLabelProps={{
        shrink: shrink,
      }}
      className={className}
      id={id ? id : `numeric-filter-${fieldName}`}
      label={hideLabel ? "" : inputLabel}
      placeholder={placeholder}
      hiddenLabel={hideLabel}
      aria-label={hideLabel ? inputLabel : ""}
      disabled={disabled}
      autoComplete="off"
      fullWidth
      error={maxValue ? Number(currentValue) > maxValue : false}
      helperText={helperText}
      value={currentValue ? currentValue : ""}
      variant="outlined"
      size="small"
      margin="dense"
      onChange={e => handleChange(e)}
    />
  );
}

export default NumericalInputField;
